import { Component, OnInit, ChangeDetectionStrategy, TemplateRef, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'shared-wizzard-header',
    templateUrl: './wizzard-header.shared.component.html',
    styleUrls: ['./wizzard-header.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizzardHeaderComponent implements OnInit {
    @Input() public counter: number = null; /* Consumer -> shared-header */
    @Input() public preContent: string | number; /* Consumer -> shared-header */
    @Input() public postContent: string | number; /* Consumer -> shared-header */
    @Input() public left: TemplateRef<any>; /* Consumer -> shared-header */
    @Input() public right: TemplateRef<any>; /* Consumer -> shared-header */
    @Input() public marginTop: OLO.Components.MARGIN_SIZE = null; /* Consumer -> shared-header */
    @Input() public marginBottom: OLO.Components.MARGIN_SIZE = null; /* Consumer -> shared-header */
    @Input() public paddingTop: OLO.Components.MARGIN_SIZE = null; /* Consumer -> shared-header */
    @Input() public paddingBottom: OLO.Components.MARGIN_SIZE = null; /* Consumer -> shared-header */
    constructor() { }

    ngOnInit(): void { }
}
